module.exports = __webpack_public_path__ + "img/carousel1.b10d4018.png";